import React from 'react';
import { Stack, Separator, getTheme, Text, ITextStyles, DefaultButton } from '@fluentui/react';
import { separatorStyle } from '../admin/SettingsStyles';
import { ITraitDefinition } from '../../services';
import { TabKey } from '../admin';
import { useHistory, useLocation } from 'react-router-dom';

export interface TraitTreeComponentInterface {
  categorizedTraits: Record<string, string[]>;
  categorizedTraitDefinitions?: Record<string, Record<string, ITraitDefinition>>;
  changeTab?: React.Dispatch<React.SetStateAction<string>>;
}

export const TraitTreeComponent = (props: TraitTreeComponentInterface) => {
  const { palette } = getTheme();
  const history = useHistory();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const style: ITextStyles = {
    root: {
      padding: 0
    }
  };

  const onAddPolicyDefClick = (trait: string, category: string) => {
    if (props.changeTab) {
      props.changeTab(TabKey.PolicyDefinition);
    }
    handleParams(category, trait);
  };

  const onEditPolicyDefClick = (trait: string, category: string) => {
    if (props.changeTab) {
      props.changeTab(TabKey.PolicyDefinition);
    }
    handleParams(category, trait);
  };

  const handleParams = (category: string, trait: string) => {
    if (params.get('category') && params.get('trait')) {
      params.delete('category');
      params.delete('trait');
    }
    params.append('category', category);
    params.append('trait', trait);
    history.push({ search: params.toString() });
  };

  return (
    <Stack tokens={{ childrenGap: 5 }}>
      {Object.keys(props.categorizedTraits || {}).map((categoryName, outerIndex) => {
        return (
          <Stack.Item key={categoryName}>
            <Text as={'h3'} className="ms-sm12 ms-md12 font-weight-bold" variant={'mediumPlus'}>
              {categoryName}
            </Text>
            <Separator styles={separatorStyle(palette)} />

            {props.categorizedTraits[categoryName].map((traitName, index) => {
              return (
                <Stack key={traitName}>
                  <Stack.Item style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Text className="ms-sm12 ms-md12" variant={'small'} style={{ marginLeft: 32 }}>
                      {traitName}
                    </Text>
                    {props.changeTab && (
                      <>
                        {props.categorizedTraitDefinitions?.[categoryName]?.[traitName] ? (
                          <DefaultButton
                            text="Edit trait definition"
                            ariaLabel={`${traitName} - Edit trait definition`}
                            onClick={() => onEditPolicyDefClick(traitName, categoryName)}
                            style={{ minWidth: 180 }}
                          />
                        ) : (
                          <DefaultButton
                            text="Add trait definition"
                            ariaLabel={`${traitName} - Add trait definition`}
                            onClick={() => onAddPolicyDefClick(traitName, categoryName)}
                            style={{ minWidth: 180 }}
                          />
                        )}
                      </>
                    )}
                  </Stack.Item>
                  {/* Little wonkiness here to skip the very last separator (after the last item) */}
                  {!(
                    index + 1 === props.categorizedTraits[categoryName].length &&
                    outerIndex + 1 === Object.keys(props.categorizedTraits).length
                  ) && <Separator styles={style} />}
                </Stack>
              );
            })}
          </Stack.Item>
        );
      })}
    </Stack>
  );
};
